import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthenticationService } from '../_services/authentication.service';
import { FrontErrorReportService } from '../_services/front-error-report.service';


@Injectable({
  providedIn: 'root'
})
export class ErrorInterceptor implements HttpInterceptor {
    constructor(
      private authenticationService: AuthenticationService,
      private errorReporter: FrontErrorReportService,
    ) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        return next.handle(request).pipe(catchError(err => {
            console.log("ErrorInterceptor", err);

            if (err.status === 401) {
              console.log("err.status === 401");
                // auto logout if 401 response returned from api
                if (this.authenticationService.user) {
                  // try refresh
                  this.authenticationService
                  .verify()
                  .toPromise()
                  .then((res) => {
                    // user refreshed
                  })
                  .catch((err) => {
                    console.log('err', err);
                    this.authenticationService.logout();
                    location.reload();
                  });
                }
            }

            // Reporting des erreurs serveur (5xx) et erreurs réseau (status 0).
            // On ignore les 401/403/404/422 (attendues métier) et les requêtes
            // marquées par le reporter lui-même (anti-boucle).
            const isOwnReportRequest = request.headers.has(FrontErrorReportService.SKIP_HEADER);
            const isReportable = err instanceof HttpErrorResponse
                && !isOwnReportRequest
                && (err.status === 0 || err.status >= 500);

            if (isReportable) {
              this.errorReporter.report({
                type: 'HttpError',
                message: err.message || err.statusText || 'HTTP error',
                stack: this.extractStack(err),
                httpStatus: err.status,
                apiUrl: request.url,
              });
            }

            const error = (err.error?.message ? err.error.message : (err.error ? err.error : err.statusText));
            return throwError(error);
        }))
    }

    private extractStack(err: HttpErrorResponse): string {
      try {
        const parts: string[] = [];
        parts.push('Method: ' + (err as any)?.url ? '' : '');
        parts.push('URL: ' + err.url);
        parts.push('Status: ' + err.status + ' ' + err.statusText);
        if (err.error) {
          parts.push('Body: ' + (typeof err.error === 'string' ? err.error : JSON.stringify(err.error)).slice(0, 1000));
        }
        return parts.join('\n');
      } catch {
        return '';
      }
    }
}
